import { IScope, IComponentOptions, IController, IPromise } from "angular";
import { IModalService, IModalServiceInstance } from "angular-ui-bootstrap";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { IBulkActionOnUsersResponse, IUser } from "../../models";
import { UserService } from "../../userService";

export type ActionType = "activate" | "deactivate" | "delete";
export interface IConfirmScope extends IScope {
  indicators: {
    loading: boolean;
  };
  closeConfirmModal(): void;
  performActionOnUser(): void;
  user: IUser;
  actionType: ActionType;
}
export class ActionOnUserCtrl implements IController {
  public static $inject = ["$rootScope", "$uibModal", "UserService", "UIErrorHandlingService"];

  private confirmationModal: IModalServiceInstance;

  actionType: ActionType;
  user: IUser;
  indicators: {
    loading: boolean;
  };
  broadcastChange: () => void;
  returnToState: () => void;

  constructor(
    private $rootScope: ITraceRootScopeService,
    private $uibModal: IModalService,
    private userService: UserService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.indicators = {
      loading: false,
    };
  }

  confirmActionOnUser = (): void => {
    this.confirmationModal = this.$uibModal.open({
      component: "confirmActionOnUser",
      windowClass: "medium-small profile-modal",
      resolve: {
        user: () => this.user,
        actionType: () => this.actionType,
        performActionOnUser: () => this.performActionOnUser,
        indicators: () => this.indicators,
      },
    });
  };

  private performActionOnUser = (): void => {
    this.$rootScope.traceAction(`${this.actionType}_user`, () => {
      this.indicators.loading = true;

      let actionUserPromise: IPromise<IBulkActionOnUsersResponse>;

      switch (this.actionType) {
        case "activate":
          actionUserPromise = this.userService.activateUsers([this.user.id]);
          break;
        case "deactivate":
          actionUserPromise = this.userService.deactivateUsers([this.user.id]);
          break;
        case "delete":
          actionUserPromise = this.userService.deleteUsers([this.user.id]);
          break;
      }

      actionUserPromise.then(
        (payload) => {
          if (payload.hasFailures) {
            const error: IUIError = {
              body: `An error occured while trying to ${this.actionType} the user`,
              type: "bad_request",
            };
            this.uiErrorHandlingService.handleIndicator(error, { indicator: "loading", inline: true });
            return;
          }

          this.indicators.loading = false;

          this.confirmationModal.close();

          if (this.returnToState) {
            this.returnToState();
          }

          if (this.broadcastChange) {
            this.broadcastChange();
          }
        },
        (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "loading", inline: true })
      );
    });
  };
}

export const ActionOnUserComponent: IComponentOptions = {
  bindings: {
    user: "<",
    actionType: "@",
    broadcastChange: "&",
    returnToState: "&",
  },
  controller: ActionOnUserCtrl,
  templateUrl: require("./action-on-user.component.jade"),
};
